import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { SeoLocale } from '../../domain/entities/seo-locale';
import {
    deriveStrippedPathFromCurrentPath,
    isNonPageRequestPath,
} from '../../domain/helpers/current-path.helper';
import { RouteContract } from '../../infrastructure';
import { RoutesRepository } from '../repositories/routes.repository';
import { PublicRouteLocaleNormalizer } from '../../infrastructure/resources/url-state/public-route-locale-normalizer';

@Injectable()
export class ApplyRouteLocaleUrlUseCase {
    public constructor(
        private readonly location: Location,
        private readonly routesRepository: RoutesRepository,
    ) {}

    public execute(
        currentUrl: string,
        currentLocale: SeoLocale,
        urlLocaleContext?: string | null,
    ): SeoLocale {
        if (isNonPageRequestPath(currentUrl)) {
            return currentLocale;
        }

        const strippedPath: string = deriveStrippedPathFromCurrentPath(currentUrl);
        const route: RouteContract | undefined =
            this.routesRepository.findMatchingRoute(strippedPath);

        if (route === undefined) {
            return currentLocale;
        }

        const normalizer: PublicRouteLocaleNormalizer = route.getNormalizerPath();
        const resolvedLocale: SeoLocale = normalizer.resolveLocale(
            currentUrl,
            currentLocale,
            urlLocaleContext,
        );
        const replacement: string | null = normalizer.handle(
            currentUrl,
            currentLocale,
            urlLocaleContext,
        );

        if (replacement !== null) {
            this.location.replaceState(replacement);
        }

        return resolvedLocale;
    }
}
